import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {Response} from "@angular/http";
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {ConfigurationProvider} from "../../configuration/configuration";
import {HttpServiceProvider} from "../../http-service/http-service";
import {Service} from "../../../model/lib/interfaces/Service";


@Injectable()
export class ServiceService {
  private serviceSubject$: BehaviorSubject<Service | undefined>;
  service$: Observable<Service | undefined>;

  private serviceErrorSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  serviceError$: Observable<boolean> = this.serviceErrorSubject$.asObservable();

  constructor(private configurationService: ConfigurationProvider,
              private httpService: HttpServiceProvider) {
    this.serviceSubject$ = new BehaviorSubject<Service | undefined>(undefined);
    this.service$ = this.serviceSubject$.asObservable();

    this.fetchService();
  }

  fetchService(): void {
    this.httpService.get(this.configurationService.apiUrl() + 'service/get/all').subscribe({
      next: (userServices: Response): void => {
        this.serviceSubject$.next(userServices.json()[0]);
        this.serviceErrorSubject$.next(false);
      },
      error: (): void => {
        this.serviceErrorSubject$.next(true);
      },
    });
  }

  fetchBusinessService(): Observable<Service> {
    return this.httpService.get(this.configurationService.apiUrl() + 'business/service/')
      .map(data => <Service>data.json());
  }
}



// WEBPACK FOOTER //
// ./src/providers/gastroflow-services/service-service/service-service.ts